export default {
  "path": "/demo/empty-index",
  "meta": {
    "name": "demo-空状态",
    "title": "Empty 空状态",
    "isComponentDoc": true,
    "category": "Basic"
  }
};